<template>
  <div>
    <el-dialog
      :title="mainTitle"
      :visible.sync="editVisible"
      width="600px"
      @close="closeEdit"
      @open="dlgOpen"
      @closed="dlgClosed"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        label-width="100px"
        :rules="rules"
        v-loading="loading"
      >
        <!-- :style="dlgBody" -->
        <el-form-item label="上级" prop="parentName">
          <el-input
            v-model.trim="editForm.parentName"
            placeholder="请选择上级"
            readonly
            style="width:90%"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model.trim="editForm.name" placeholder="请输入名称" clearable style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortId">
          <el-input v-model.number="editForm.sortId" placeholder="请输入排序" clearable style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="权限值" prop="rightValue">
          <el-input
            v-model.trim="editForm.rightValue"
            placeholder="请输入权限值"
            clearable
            style="width:90%"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('editForm')">取 消</el-button>
        <el-button type="primary" @click="onSubmit('editForm')" :disabled="btnDisabled">确 定</el-button>
      </span>
    </el-dialog>
    <OrganizationDlg
      v-if="organizationDlgShow"
      @node-data="handleCallData"
      ref="organizationDlgRef"
    ></OrganizationDlg>
  </div>
</template>
<script>
import DialogResize from "@/utils/DialogResize.js";
import OrganizationDlg from "../organizationManage/OrganizationDlg.vue";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [DialogResize],
  components: {
    OrganizationDlg
  },
  computed: {},
  data() {
    return {
      loading: false,
      btnDisabled: false,
      operateFlag: "",
      nowParentId: "",
      mainTitle: "",
      parentId: "",
      parentName: "",
      editVisible: false,
      organizationDlgShow: false,
      systemId: "",
      editForm: {
        parentId: "",
        parentName: "",
        name: "",
        sortId: 1,
        systemId: "",
        rightValue: ""
      },
      rules: {
        name: [
          { required: true, message: "名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "名称输入不能超过50个字符，请重新输入",
            trigger: "blur"
          }
        ],
        sortId: [
          {
            required: true,
            message: "排序不能为空",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (/^[1-9]\d{0,8}$/.test(value) == false) {
                  callback(new Error("只能输入0-9位的数字"));
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        rightValue: [
          { required: false, message: "权限值不能为空", trigger: "change" },
          {
            min: 1,
            max: 50,
            message: "权限值输入不能超过50个字符，请重新输入",
            trigger: "blur"
          }
          // {
          //   pattern: /^[0-9]*$/,
          //   message: "权限值只能输入数字"
          // }
        ]
      }
    };
  },
  methods: {
    init(param, row, operateFlag, level) {
      this.loading = false;
      this.btnDisabled = false;
      this.nowParentId = param.parentId;
      if (operateFlag == "add") {
        this.parentId = param.parentId;
        this.parentName = param.parentName;
        this.mainTitle = "新增";
        this.editForm = {
          id: "",
          parentId: param.parentId,
          parentName: param.parentName,
          name: "",
          sortId: 1,
          systemId: param.systemId,
          rightValue: ""
        };
      }
      if (operateFlag == "topAdd") {
        this.mainTitle = "新增";
        this.parentId = 0;
        this.parentName = "顶级";
        this.editForm = {
          id: "",
          parentId: 0,
          parentName: "顶级",
          name: "",
          sortId: 1,
          systemId: param.systemId
        };
      }

      if (operateFlag == "update") {
        this.mainTitle = "编辑";
        this.parentId = param.parentId;
        this.parentName = param.parentName;
        if (level == "topEdit") {
          this.getDataById(row.id, 0, "顶级");
        } else {
          this.getDataById(row.id, param.parentId, param.parentName);
        }
      }
      this.editVisible = true;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.btnDisabled = true;
          var v = this.editForm;
          let param = {
            id: v.id,
            parentId: v.parentId,
            name: v.name,
            sortId: v.sortId,
            systemId: v.systemId,
            rightValue: v.rightValue
          };
          this.saveAndUpdate(param);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveAndUpdate(param) {
      SettingApi.getClass()
        .saveRight(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.$message.success("保存成功！");
            this.loading = false;
            this.btnDisabled = false;
            this.editVisible = false;
            this.$parent.onloadGroup();
            if (this.nowParentId != "" && this.nowParentId != null) {
              this.$parent.getListData(this.nowParentId);
            }
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.editForm.parentName = "";
      this.editForm.parentId = "";
      this.editVisible = false;
    },
    openElTreeDialog() {
      this.organizationDlgShow = true;
      this.$nextTick(() => {
        // type 必传 0表示全部的组织架构 每个都可以选 1 表示分部  2部门
        // id  可选  传入id可以默认选中当前传入的id节点 如果不需要默认选中 就传null
        this.$refs.organizationDlgRef.init(0, this.nowParentId, null);
      });
    },
    handleCallData(nodeData) {
      this.editForm.parentName = nodeData.name;
      this.editForm.parentId = nodeData.id;
    },
    closeEdit() {
      this.$refs["editForm"].resetFields();
      this.editForm.parentName = "";
      this.editForm.parentId = "";
    },
    getDataById(id, parentId, parentName) {
      this.loading = true;
      this.btnDisabled = true;
      SettingApi.getClass()
        .getRightById(id)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.loading = false;
            this.btnDisabled = false;
            let data = res2.data.data;
            this.editForm = {
              id: data.id,
              parentId: parentId,
              parentName: parentName,
              name: data.name,
              sortId: data.sortId,
              rightValue: data.rightValue,
              systemId: data.systemId
            };
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    }
  }
};
</script>
<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px !important;
  height: 150px !important;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid aliceblue;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
</style>
